var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFilterSvg(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "heroicons:adjustments-horizontal"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Union",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.7324 5H21V6.5H10.937C10.715 7.36261 9.93192 8 9 8C8.06808 8 7.28503 7.36261 7.06301 6.5H3V5H7.26756C7.61337 4.4022 8.25972 4 9 4C9.74028 4 10.3866 4.4022 10.7324 5ZM21 11H16.7324C16.3866 10.4022 15.7403 10 15 10C14.2597 10 13.6134 10.4022 13.2676 11H3V12.5H13.063C13.285 13.3626 14.0681 14 15 14C15.9319 14 16.715 13.3626 16.937 12.5H21V11ZM10.7324 17H21V18.5H10.937C10.715 19.3626 9.93192 20 9 20C8.06808 20 7.28503 19.3626 7.06301 18.5H3V17H7.26756C7.61337 16.4022 8.25972 16 9 16C9.74028 16 10.3866 16.4022 10.7324 17Z",
    fill: "#4B3628"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilterSvg);
export default __webpack_public_path__ + "static/media/FilterSVG.6c5cf9a0c8cfcee91e7b424d480b46a9.svg";
export { ForwardRef as ReactComponent };